import { useState } from "react";
import "./_Styles/BannerModeDevelopment.css"
import { APP_CONFIG_MODE } from "../AppConfig.Mode";
import { useLanguage } from "../../APP/Hooks/Contexts/Translate/useLanguageContext";


export const BannerModeDevelopment = () => {

    const [IS_CLOSED, setIsClosed] = useState(false);

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.banner ?? {};

    const IS_VISIBLE = APP_CONFIG_MODE.APP__IS_NODE_ENV && APP_CONFIG_MODE.APP__SHOW_DEV_BANNER;

    if (!IS_VISIBLE || IS_CLOSED) return null;

    return (
        <div className="LStudio__app_container_banner_development" role="status" aria-live="polite">

            <p className="LStudio__app_content_banner_development_text">
                {APP_CONFIG_MODE.APP__DEV_BANNER_MESSAGE ?? TEXT.devMode}
            </p>

            <button type="button" className="LStudio__app_content_banner_development_close"
                onClick={() => setIsClosed(true)} title={TEXT.devModeHide}
                aria-label={TEXT.devModeHideAria}> ✕
            </button>

        </div>
    );
};